<script lang="ts" setup>
import BaseButton from "@/components/Base/Button.vue";
import { isUser } from "@/stores/user";

defineOptions({ name: "IncognitoOverlay" });

const { t } = useI18n();
const userStore = useUserStore();
const incognitoStore = useIncognitoStore();
const { logout } = useIncognito();

const router = useRouter();

const handleLogout = async (): Promise<void> => {
  const path = incognitoStore.path;

  const userId = incognitoStore.userId;

  await logout();

  // use-case: teacher is in incognito mode (as pupil)
  if (userStore.isIncognito && isUser(userStore.user)) {
    incognitoStore.userId = userStore.user?.id;
  }

  if (path) {
    await router.push(path);
  } else if (userStore.isAdmin) {
    if (userId) {
      window.location.href = `/backoffice/users/${userId}`;
    } else {
      window.location.href = `/backoffice/users`;
    }
  } else {
    await router.push("/");
  }
};

// called when still in incognito mode and the state is filled with incognito user
</script>
<template>
  <div
    v-if="userStore.isIncognito"
    class="incognito"
    data-test="hint-invitee-impersonation"
  >
    <div class="alert alert-warning p-2 flex-column">
      <p class="mb-2">
        {{ t("incognito.signedInAs") }}
        <br />
        <strong :title="userStore.name">
          {{ userStore.shortName }}
          <span v-if="isUser(userStore.user)"> ({{ userStore.user.id }}) </span>
        </strong>
      </p>
      <BaseButton
        kind="secondary"
        size="s"
        data-testid="button-stop_invitee_impersonation"
        @click="handleLogout"
      >
        {{ t("incognito.stop") }}
      </BaseButton>
    </div>
  </div>
</template>
